import React from 'react';
import faqsRoutes from './faqs';

const Admins = React.lazy(() =>
  import(/* webpackChunkName: "admins" */ '../pages/master/Admins')
);

const AdminsEdit = React.lazy(() =>
  import(/* webpackChunkName: "admin-edit" */ '../pages/master/AdminsEdit')
);

const CreateNewAdmin = React.lazy(() =>
  import(
    /* webpackChunkName: "create-new-admin" */ '../pages/master/CreateNewAdmin'
  )
);

const Users = React.lazy(() =>
  import(/* webpackChunkName: "users" */ '../pages/master/Users')
);

const CreateNewUser = React.lazy(() =>
  import(
    /* webpackChunkName: "create-new-user" */ '../pages/master/CreateNewUser'
  )
);

const UsersView = React.lazy(() =>
  import(/* webpackChunkName: "user-view" */ '../pages/master/UsersView')
);

const Algos = React.lazy(() =>
  import(/* webpackChunkName: "algos" */ '../pages/master/Algos')
);

const AlgosView = React.lazy(() =>
  import(/* webpackChunkName: "algos-view" */ '../pages/master/AlgosView')
);

const Jobs = React.lazy(() =>
  import(/* webpackChunkName: "jobs" */ '../pages/master/Jobs')
);

const Profile = React.lazy(() =>
  import(/* webpackChunkName: "profile" */ '../pages/master/Profile')
);

const ManageInstance = React.lazy(() =>
  import(
    /* webpackChunkName: "manage-instance" */ '../pages/master/ManageInstance/ManageInstance'
  )
);

const NotificationMonitoring = React.lazy(() =>
  import(
    /* webpackChunkName: "notification-monitoring" */ '../pages/master/NotificationMonitoring'
  )
);

const GenerateLoginLink = React.lazy(() =>
  import(
    /* webpackChunkName: "GenerateLoginLink" */ '../pages/master/GenerateLoginLink'
  )
);

const CreateBrokerFamilyAccount = React.lazy(() =>
  import(
    /* webpackChunkName: "create-broker-family-account" */ '../pages/master/CreateBrokerFamilyAccount'
  )
);

const Coupons = React.lazy(() =>
  import(/* webpackChunkName: "coupons" */ '../pages/master/Coupons')
);

const CreateNewCoupon = React.lazy(() =>
  import(
    /* webpackChunkName: "create-new-coupon" */ '../pages/master/CreateNewCoupon'
  )
);

const CouponsEdit = React.lazy(() =>
  import(/* webpackChunkName: "coupon-edit" */ '../pages/master/CouponsEdit')
);

export default [
  {
    id: 'admins',
    path: '/admins',
    name: 'Administrators',
    component: Admins,
    exact: true,
  },
  {
    id: 'admin-edit',
    path: '/admins/:id',
    name: 'Administrators Edit',
    component: AdminsEdit,
    excludeFromSidebar: true,
  },
  {
    id: 'create-new-admin',
    path: '/create/admin',
    name: 'Create New Administrator',
    component: CreateNewAdmin,
    excludeFromSidebar: true,
  },
  {
    id: 'users',
    path: '/users',
    name: 'Users',
    component: Users,
    exact: true,
  },
  {
    id: 'create-new-user',
    path: '/create/user',
    name: 'Create New User',
    component: CreateNewUser,
    excludeFromSidebar: true,
  },
  {
    id: 'generate-login-link',
    path: '/users/:id/login',
    name: 'Generate Login Link',
    component: GenerateLoginLink,
    excludeFromSidebar: true,
  },
  {
    id: 'user-view',
    path: '/users/:id',
    name: 'Users View',
    component: UsersView,
    excludeFromSidebar: true,
  },
  {
    id: 'coupons',
    path: '/coupons',
    name: 'Coupons',
    component: Coupons,
    exact: true,
  },
  {
    id: 'coupon-edit',
    path: '/coupons/:id',
    name: 'Coupons Edit',
    component: CouponsEdit,
    excludeFromSidebar: true,
  },
  {
    id: 'create-new-coupon',
    path: '/create/coupon',
    name: 'Create New Coupon',
    component: CreateNewCoupon,
    excludeFromSidebar: true,
  },
  {
    id: 'algos',
    path: '/algos',
    name: 'Algos',
    component: Algos,
    exact: true,
  },
  {
    id: 'algo-view',
    path: '/algos/:id',
    name: 'Algos View',
    component: AlgosView,
    excludeFromSidebar: true,
  },
  {
    id: 'jobs',
    path: '/jobs',
    name: 'Jobs',
    component: Jobs,
    exact: true,
  },
  {
    id: 'profile',
    path: '/profile',
    name: 'Profile',
    component: Profile,
    exact: true,
    excludeFromSidebar: true,
  },
  {
    id: 'create-broker-family-account',
    path: '/create/broker-family-account/:id',
    name: 'Create broker family account',
    component: CreateBrokerFamilyAccount,
    excludeFromSidebar: true,
  },
  {
    id: 'manage-instance',
    path: '/manage-instance',
    name: 'Manage Instance',
    component: ManageInstance,
    exact: true,
  },
  {
    id: 'notification-monitoring',
    path: '/notification-monitoring',
    name: 'Notification Monitoring',
    component: NotificationMonitoring,
    exact: true,
  },
  ...faqsRoutes,
];
